class Storage {
  static l_set(key: any, value: any) {
    return localStorage.setItem(JSON.stringify(key), JSON.stringify(value));
  }

  static l_get(key: any) {
    var data = localStorage.getItem(JSON.stringify(key));
    var res = eval("(" + data + ")"); // todo eval禁止使用
    return res;
  }

  static l_remove(key: any) {
    return localStorage.removeItem(JSON.stringify(key));
  }

  static l_clear() {
    return localStorage.clear();
  }

  static s_set(key: any, value: any) {
    return sessionStorage.setItem(JSON.stringify(key), JSON.stringify(value));
  }

  static s_get(key: any) {
    var data = sessionStorage.getItem(JSON.stringify(key));
    var res = eval("(" + data + ")"); // todo eval禁止使用
    return res;
  }

  static s_remove(key: any) {
    return sessionStorage.removeItem(JSON.stringify(key));
  }

  static s_clear() {
    return sessionStorage.clear();
  }
}

export default Storage;
